/** @jsxImportSource @emotion/react */
import { EuiPageTemplate } from "@inscopix/ideas-eui";
import { PanelProjects } from "components/PanelProjects/PanelProjects";
import { PageOrganizationSideBar } from "./PageOrganizationSidebar";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { CallOutQuotas } from "components/CallOutQuotas/CallOutQuotas";
import { CallOutContract } from "components/CallOutContract/CallOutContract";
import { TenantType } from "types/constants";
import { DemoProjects } from "components/DemoProjects/DemoProjects";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { css } from "@emotion/react";
import { useRef } from "react";

export const PageOrganizationDashboard = () => {
  const currentTenant = useTenantContext((s) => s.currentTenant);
  const personalSpaceId = useUserContext((s) => s.personalSpace?.id);
  const isPersonalSpace = currentTenant.tenantType === TenantType.PERSONAL;
  const isCurrentUsersPersonalSpace =
    isPersonalSpace && currentTenant.id === personalSpaceId;
  const virtuaScrollRef = useRef<HTMLDivElement>(null);

  return (
    <EuiPageTemplate
      panelled={true}
      bottomBorder={"extended"}
      grow={true}
      mainProps={{
        css: css`
          overflow: auto;
          max-block-size: calc(100vh - var(--euiFixedHeadersOffset, 0));
        `,
      }}
    >
      <CallOutContract format="call_out" />
      <CallOutQuotas />
      <EuiPageTemplate.Sidebar minWidth={300} sticky={true}>
        <PageOrganizationSideBar isPersonalSpace={isPersonalSpace} />
      </EuiPageTemplate.Sidebar>
      <div
        style={{
          width: "100%",
          height: "100%",
          overflowY: "auto",
          // opt out browser's scroll anchoring on header/footer because it will conflict to scroll anchoring of virtualizer
          overflowAnchor: "none",
        }}
        ref={virtuaScrollRef}
      >
        <PanelProjects
          tenantId={currentTenant.id}
          virtuaScrollRef={virtuaScrollRef}
        />
        {isCurrentUsersPersonalSpace && <DemoProjects />}
      </div>
    </EuiPageTemplate>
  );
};
